import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import config from 'config'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import history from 'srcReact/helpers/history'
import { decode } from 'html-entities/lib/index'
import WorkplaceLabel from 'srcReact/components/common2/WorkplaceLabel'
import Tag from 'srcReact/components/common2/Tag'

const Header = ({ tabRightContent, isDesktop }) => {
  const { t } = useTranslation()
  const {
    common: { isNative, isMobile },
    groupHome: { group }
  } = useSelector((state) => state)

  const getGroupRoleColor = (role) => {
    switch (role) {
      case 'organizer':
        return 'yellow'
      case 'co-organizer':
        return 'yellow'
      default:
        return 'bluepurple'
    }
  }

  const handleInvite = () => {
    //nativeapp
    if (isNative) {
      window.location = config.webUrl + `/0/group/${group.id}/invite-members`
      return
    }
    history.push(`/0/group/${group.id}/invite-members`)
  }

  return (
    <div className={styles.headerContainer}>
      <div
        className={`${styles.banner} ${group.picture.url ? null : styles['defaultImage']}`}
        style={
          group.picture.url
            ? {
                backgroundImage: `url(${group.picture.url})`
              }
            : null
        }>
        {!isDesktop && <div className={styles.overlay} />}
        <h2 className={styles.heading}>{decode(group.name)}</h2>
        {group.logged_user.group_role !== 'none' && (
          <Tag
            color={getGroupRoleColor(group.logged_user.group_role)}
            text={t(`components.avatar.${group.logged_user.group_role}`)}
            position='left'
            className={styles.member}
          />
        )}
        <div className={styles.groupTags}>
          {group?.workplace && (
            <WorkplaceLabel
              id={group.workplace?.id}
              name={group.workplace?.name}
              color={group.workplace?.color}
              initial={group.workplace?.initials}
              className={styles.wpLabel}
            />
          )}

          {group.privacy_setting === 'private' && (
            <div className={styles.isPrivate}>
              <Icon name='mask' styleModifier={styles.maskIcon} />
              {!isMobile && !isNative && t('groupHome.header.private')}
            </div>
          )}
        </div>
        {group.privacy_setting === 'public' && group.is_general == 1 && (
          <Tag text={t('groupHome.header.general')} color='blue' className={styles.isGeneral} position='left' />
        )}
        {group.group_type === 'expertise' && (
          <Tag
            text={t('group.createGroup.groupType.expertise.title')}
            color='purple'
            className={styles.isExpertise}
            position='left'
          />
        )}
        {isDesktop && group.is_general == 1 && (
          <div className={styles.general}>
            <div className={`${styles.workplaceName} ${styles[group.workplace.color]}`}>{group.workplace.name}</div>
            <div className={`${styles.backgroundImage} ${styles[group.workplace.color]}`} />
          </div>
        )}
        {group.group_type === 'expertise' && (
          <div className={styles.expertiseGroup}>
            <Icon styleModifier={styles.icon} name='star-solid' size='large40' />
            <div className={`${styles.backgroundImage} ${styles.purple}`} />
          </div>
        )}
      </div>
    </div>
  )
}

export default Header
